import * as actionTypes from './actions/actionTypes';

const initialState = {
    account: null,
    isBuyoutQuoteBlocked: false,
};

export const actionCreators = {
    accountSelected: (account) => ({ type: actionTypes.ACCOUNT_SELECTED, account: account }),
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === actionTypes.ACCOUNT_SELECTED) {
        return {
            ...state,
            account: {
                value: action.account ? action.account.value : null,
                data: action.account?.data?.Account,
            },
        };
    }

    return state;
};
